/**
 * Reveal.js tweaks: viewport vars, full-screen slides, custom nav labels,
 * slide number → overview, data-reveal-link / data-reveal-next.
 * Composes viewport, fullscreen, links, overview, nav.
 */

import { installViewportBottomInsetVar } from './viewport';
import { setupFullScreenSlides } from './fullscreen';
import { setupRevealLinks } from './links';
import { setupSlideNumberToggleOverview } from './overview';
import { setupCustomNavLabels } from './nav';
import { setupKeyboardShortcuts } from './keyboard';
import { installPauseBreakUi } from '../services/pause-break';

export interface RegisterRevealTweaksOpts {
  viewportVars?: boolean;
}

/**
 * Register all Reveal tweaks.
 */
export function registerRevealTweaks(opts: RegisterRevealTweaksOpts = {}): void {
  const { viewportVars = true } = opts;
  if (viewportVars) installViewportBottomInsetVar();

  if (typeof Reveal === 'undefined') {
    return;
  }

  setupRevealLinks();
  setupSlideNumberToggleOverview();
  setupKeyboardShortcuts();
  installPauseBreakUi();

  if (Reveal.isReady && Reveal.isReady()) {
    setupFullScreenSlides();
    setupCustomNavLabels();
  } else {
    Reveal.on?.('ready', () => {
      setupFullScreenSlides();
      setupCustomNavLabels();
    });
  }
}
